import { ReactNode } from 'react';
import { UrlObject } from 'url';
import { LogoCreditFlowResearchStandart } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Standart';
import { LogoCreditFlowResearchText } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Text';
import Flex from '@creditflowresearch/uilib/Flex';
import { Link } from '@framework/router/Next/Link';

import style from './logo.module.scss';

interface ILogoProps {
  url?: string | UrlObject | null,
  hamburgerToggle?: ReactNode,
  dataTest?: string,
}

const Logo = ({ url, hamburgerToggle, dataTest = 'headerLogo' }: ILogoProps) => (
  <Flex align="center">
    <Link to={ url || '/' } dataTest={ dataTest } disabled={ url === null }>
      <LogoCreditFlowResearchStandart className={ style.logo } />
    </Link>
    <Flex
      className={ style.mobileLogoContainer }
      align="center"
      gap={ { sm: 0, md: 20 } }
      direction="row"
    >
      { hamburgerToggle }
      <Link to={ url || '/' } dataTest={ `${ dataTest }-mobile` } disabled={ url === null }>
        <LogoCreditFlowResearchText className={ style.logoMobile } />
      </Link>
    </Flex>
  </Flex>
);

export default Logo;
